import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_DDOSProtect",
  "use": "icon-icon_DDOSProtect-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_DDOSProtect\">\n    <path d=\"M11 0L2 4C2 4 2 8 2 10C2 17.83 8.439 21.486 11 22C13.561 21.486 20 17.83 20 10C20 8 20 4 20 4L11 0ZM18 10C18 16.134 13.215 19.254 11 19.937C8.785 19.254 4 16.134 4 10V5.3L11 2.189L18 5.3V10Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol